import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-display-details',
    templateUrl: './display-details.component.html',
    styleUrls: ['./display-details.component.scss'],
    standalone: false
})
export class DisplayDetailsComponent implements OnInit {

  user: ContactDetails;
  flaggedDetails: string = '';
  constructor(@Inject(MAT_DIALOG_DATA) public data, private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  ngOnInit() {
    if (this.data.type === 'user') {
      this.InitializeUserDetails(this.data.element);
    } else if (this.data.type === 'flag') {
      this.InitializeFlaggedDetails();
    }
  }

  /**
   *  Initializes user details
   * @param user User details
   */
  InitializeUserDetails(user) {
    this.user = {
      organisationName: user.organisationName,
      firstName: user.firstName,
      lastName: user.lastName,
      email: user.email,
      mobile: user.mobile,
      phone: user.phone
    };
  }

  /** Initialize the flagged details */
  InitializeFlaggedDetails() {
    this.http.post(this.baseUrl + 'api/monitorMarkets/getFlaggedDetails/' + this.data.marketId, this.data.element, {responseType: 'text'}).subscribe(result => {
      this.flaggedDetails = result;
      if (this.flaggedDetails === '') {
        this.flaggedDetails = 'Something went wrong. Please try again.';
      }
    }, error => {
      console.error(error);
    });
  }

  // /** Cancel button event */
  // OnCancel() {
  //   this.dialogRef.close();
  // }

}

/** An inteface to access selected user's contact details */
interface ContactDetails {
  organisationName: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  mobile: string;
}

